// 自动阅卷
enum EnumAuditStatus {
  EnumAuditStatusNoAudit = 0, // 待评估
  EnumAuditStatusPass, // 通过
  EnumAuditStatusWait, // 待定
  EnumAuditStatusRefuse // 拒绝
}

// ai推荐状态
enum EnumAiRecommendStatus {
  EnumAiRecommendStatusDefault = 0, // 默认
  EnumAiRecommendStatusNotRecommend = 10, // 不推荐
  EnumAiRecommendStatusNormal = 20, // 一般
  EnumAiRecommendStatusRecommend = 30, // 推荐
  EnumAiRecommendStatusVeryRecommend = 40 // 非常推荐
}

type MergeType = "AND" | "OR";

class Option {
  name = "";
  value?: number | string = "";
}

export class StructRuleNodeDetailV4 {
  attribute = ""; // 标签属性
  relationship = ""; // 标签关系
  /**      start     */
  /**   标签值，根据标签属性的类型存储   */
  valueInt = 0;
  valueRange: number[] | null = null;
  valueStrings: string[] | null = null;
  /**      end     */
  /**      start     */
  /**   标签属性关联的属性对应的字段 eg：登记信息对应paramName   */
  questionId = 0; // 题目
  paramName = "";
  dimensionName = "";
  dimensionGroupName = "";
  cvArgName = "";
  /**      end     */

  // 前端使用
  props?: string[] | null = null; // 标签属性可能关联多个，用列表
  propAttrList?: Option[][] = []; // 同上，多个选择项列表
  dataTypeList?: Option[] = []; // 标签关系的列表
  valueOption?: Option[] | null = null; // 标签值如果是选择时使用

  // 输入框绑定的值
  value?: string | number | string[] | number[] = "";
  value1? = "";
  value2? = "";
}

export class StructRuleNodeV4 {
  ruleId = 0;
  mergeType: MergeType = "AND";
  detail = new StructRuleNodeDetailV4();
  subList: StructRuleNodeV4[] = [];
  // subList: StructRuleNodeV4[] | null = null;
  // 前端使用
  ruleKey? = 0;

  public objectArrayClasses() {
    return {
      subList: StructRuleNodeV4
    };
  }
}

export class StructApplicationRuleV4 {
  applicationRuleId = 0;
  type = "";
  sort = 0;
  auditStatus: EnumAuditStatus | "" = "";
  auditDesc = "";
  aiRecommendStatus: EnumAiRecommendStatus | "" = "";
  tagName = ""; // 打标签
  subExamId = 0; // 集联面试
  mokaCustomResult = ""; // moka成绩回传和报告总分
  matchRuleRoot = new StructRuleNodeV4();
  messageType: number | "" = "";
  message = "";
  dimensionLevelDesc = "";
  dimensionLevel: number | "" = "";
  // 前端使用
  applicationKey? = 0;
  tagStatusList: Option[] | null = null; // 二级选择列表
}

// 规则应用类型
export const applicationTypeList = [
  {
    label: "自动阅卷",
    value: "自动阅卷",
    statusList: [
      { name: "通过", value: 1 },
      { name: "待定", value: 2 },
      { name: "拒绝", value: 3 }
    ],
    propName: "auditDesc"
  },
  {
    label: "AI推荐",
    value: "AI推荐",
    statusList: [
      { name: "不推荐", value: 10 },
      { name: "一般", value: 20 },
      { name: "推荐", value: 30 },
      { name: "非常推荐", value: 40 }
    ],
    propName: ""
  },
  { label: "打标签", value: "打标签", statusList: null, propName: "tagName" },
  {
    label: "自定义Moka成绩回传",
    value: "自定义Moka成绩回传",
    statusList: null,
    propName: "mokaCustomResult"
  },
  {
    label: "自定义MokaAI面试评估结果",
    value: "自定义MokaAI面试评估结果",
    statusList: null,
    propName: "mokaCustomResult"
  },
  {
    label: "自定义moka详情考试结果",
    value: "自定义moka详情考试结果",
    statusList: null,
    propName: "mokaCustomResult"
  },
  // { label: "自定义报告总分展示", value: "自定义报告总分展示", statusList: null, propName: "tagName" },
  {
    label: "报告评价",
    value: "报告评价",
    statusList: [
      { name: "优点", value: 1 },
      { name: "缺点", value: 2 },
      { name: "建议", value: 3 },
      { name: "中性", value: 4 }
    ],
    propName: "message"
  },
  {
    label: "维度组评价",
    value: "维度组评价",
    statusList: [
      { name: "三档低", value: 10 },
      { name: "三档中", value: 20 },
      { name: "三档高", value: 30 },
      { name: "四档低", value: 11 },
      { name: "四档中", value: 21 },
      { name: "四档高", value: 31 },
      { name: "四档差", value: 41 }
    ],
    propName: "dimensionLevelDesc",
    disabled: false
  },
  {
    label: "维度评价",
    value: "维度评价",
    statusList: [
      { name: "三档低", value: 10 },
      { name: "三档中", value: 20 },
      { name: "三档高", value: 30 },
      { name: "四档低", value: 11 },
      { name: "四档中", value: 21 },
      { name: "四档高", value: 31 },
      { name: "四档差", value: 41 }
    ],
    propName: "dimensionLevelDesc",
    disabled: false
  }
];

// 使用value值的标签类型，直接按名字省的前端自己拼一个type，不过，加标签类型要维护一下这里
export const useIntList = Object.freeze([
  "AI得分",
  "候选人参加面试次数",
  "候选人当前参加面试次数",
  "维度得分",
  "维度成绩百分比",
  "维度组成绩百分比",
  "题目得分",
  "普通话百分位",
  "英语等级"
]); // dataType为int
export const useStringList = Object.freeze([
  "填空题答案",
  "登记信息",
  "简历信息",
  "选择题选项"
]); // dataType为string
export const useRangeList = Object.freeze([
  "AI得分区间",
  "维度得分区间",
  "维度成绩百分比区间",
  "维度组成绩百分比区间",
  "题目得分区间"
]); // dataType为range

// 校验项
export const appRules = {
  type: [{ required: true, message: "请选择", trigger: ["blur", "change"] }],
  auditStatus: [
    { required: true, message: "请选择", trigger: ["blur", "change"] }
  ],
  messageType: [
    { required: true, message: "请选择", trigger: ["blur", "change"] }
  ],
  dimensionLevel: [
    { required: true, message: "请选择", trigger: ["blur", "change"] }
  ],
  aiRecommendStatus: [
    { required: true, message: "请选择", trigger: ["blur", "change"] }
  ],
  auditDesc: [
    { required: true, message: "请选择", trigger: ["blur", "change"] }
  ],
  tagName: [{ required: true, message: "请选择", trigger: ["blur", "change"] }],
  message: [{ required: true, message: "请选择", trigger: ["blur", "change"] }],
  dimensionLevelDesc: [
    { required: true, message: "请选择", trigger: ["blur", "change"] }
  ],
  mokaCustomResult: [
    { required: true, message: "请输入", trigger: ["blur", "change"] }
  ]
};

export const tagRules = {
  attribute: [
    {
      required: true,
      message: "请选择标签属性",
      trigger: ["blur", "change"]
    }
  ],
  relationship: [
    {
      required: true,
      message: "请选择标签关系",
      trigger: ["blur", "change"]
    }
  ],
  value: [
    { required: true, message: "请输入标签值", trigger: ["blur", "change"] }
  ],
  value1: [
    { required: true, message: "请输入标签值", trigger: ["blur", "change"] }
  ],
  value2: [
    { required: true, message: "请输入标签值", trigger: ["blur", "change"] }
  ]
};
